export default __webpack_public_path__ + "static/media/wh_ep2_wenny_annoyed.96dc75a9.png";